import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCursor } from "../cursor/useCursor";
import { CURSORS } from "../cursor/cursors";

const SWIPE_THRESHOLD = 50;

export default function CertificateStack({
  certificates = [],
}) {
  const [cards, setCards] = useState(certificates);
  const [isDragging, setIsDragging] = useState(false);
  const {cursor} = useCursor()

  if (!certificates.length) return null;

  const activeCertificate = cards[0];

  const handleDragEnd = (_, info) => {
    setIsDragging(false);

    const distance = Math.sqrt(
      info.offset.x ** 2 + info.offset.y ** 2
    );

    if (distance > SWIPE_THRESHOLD) {
      setCards((prev) => {
        const [first, ...rest] = prev;
        return [...rest, first];
      });
    }
  };

  

  return (
    <div className="flex h-full w-full flex-col">

      {/* Certificate area */}
      <div className="relative flex min-h-0 flex-1 items-center justify-center">

        <div
          className="
            relative
            aspect-[4/3]
            w-[72%]
            max-w-[420px]
            sm:w-[65%]
            md:w-[75%]
            lg:w-[70%]
          "
          style={{
            perspective: "1000px",
          }}
        >
          {cards.map((certificate, index) => {
            const isTop = index === 0;

            const scale = 1 - index * 0.045;
            const y = -index * 7;
            const x = index * 8;
            const rotate = index * -4;

            return (
              <motion.div
              {...cursor({...CURSORS.default,background:'#CFEF00',border:'none',text:"swipe",size:90})}
                key={certificate.id}
                drag={isTop}
                dragConstraints={{
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                }}
                dragElastic={0.7}
                dragMomentum={false}
                onDragStart={() => setIsDragging(true)}
                onDragEnd={handleDragEnd}
                animate={{
                  x,
                  y,
                  scale,
                  rotate,
                  zIndex: cards.length - index,
                }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  damping: 30,
                }}
                whileDrag={{
                  scale: 1.04,
                  rotate: 0,
                  zIndex: 100,
                }}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  borderRadius: 18,
                  overflow: "hidden",
                  background: "#ffffff",
                  cursor: isTop
                    ? isDragging
                      ? "grabbing"
                      : "grab"
                    : "default",
                  userSelect: "none",
                  boxShadow:
                    index === 0
                      ? "0 15px 35px rgba(0,0,0,0.12)"
                      : "0 8px 20px rgba(0,0,0,0.08)",
                }}
              >
                <img
                  src={certificate.image}
                  alt={certificate.title}
                  draggable={false}
                  className="h-full w-full object-cover"
                />
              </motion.div>
            );
          })}
        </div>
      </div>

      {/* Active certificate name */}
      <div
        className="
          flex
          h-12
          shrink-0
          items-center
          justify-center
          px-4
          text-center
        "
      >
        <motion.p
          key={activeCertificate.id}
          initial={{
            opacity: 0,
            y: 8,
          }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.25,
          }}
          className="
            font-minecraft
            text-xs
            uppercase
            tracking-[0.12em]
            text-neutral-700
            sm:text-sm
          "
        >
          {activeCertificate.title}
        </motion.p>
      </div>
    </div>
  );
}